export const BASE_URL = "https://go-scandinavia.herokuapp.com/";
export const API_URL = (slug) => `${BASE_URL}${slug}`;
